import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

export function HtmlTags() {
  const { locale } = useIntl();

  return (
    <Helmet
      defer={false}
      htmlAttributes={{
        lang: locale,
      }}
    >
      <meta name="google" content="notranslate" />
    </Helmet>
  );
}
